import { render, staticRenderFns } from "./ChangeValue.vue?vue&type=template&id=8b0d7b6a&scoped=true"
import script from "./ChangeValue.vue?vue&type=script&lang=js"
export * from "./ChangeValue.vue?vue&type=script&lang=js"
import style0 from "./ChangeValue.vue?vue&type=style&index=0&id=8b0d7b6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0d7b6a",
  null
  
)

export default component.exports